import { Button, Modal, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import BSSelect from "../../../common/js/components/BSSelect";
import {
    marketAreasForResearchSnapshot,
    micromarketOptionsForResearch,
    propertyTypeFilterOptionsForResearchSnapshot,
    submarketOptionsForResearch,
    yearsForResearchSnapshot,
} from "../property/constants";
import { quarters } from "../utils/constants";
import operations from "./ducks/operations";

const StyledHeaderText = styled("h4")(() => ({
    marginTop: "45px",
    textAlign: "left",
    fontSize: "18px",
    marginLeft: "24px",
}));

const StyledModalContainer = styled("div")(({ theme }) => ({
    margin: "0 auto",
    marginTop: "10%",
    position: "relative",
    alignItems: "center",
    borderRadius: "3px",
    "&:focus": {
        outline: "none",
    },
    width: "525px",
    height: "675px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    overflowY: "auto",
}));

const StyledSelectionColumn = styled("div")({
    margin: "24px 24px 0px 24px",
});

const ResearchSnapshotModal = (props) => {
    const { closeModal, modalOpen, snapshotResponse } = props;

    const [sending, setSending] = useState(false);
    const [year, setYear] = useState(yearsForResearchSnapshot()[1].value);
    const [quarter, setQuarter] = useState("Select");
    const [marketArea, setMarketArea] = useState("Select");
    const [subMarketArea, setSubMarketArea] = useState("All");
    const [microMarketArea, setMicroMarketArea] = useState("All");
    const [propertyType, setPropertyType] = useState("All");

    const onExitModal = () => {
        setSending(false);
        setYear(yearsForResearchSnapshot()[1].value);
        setQuarter("Select");
        setMarketArea("Select");
        setSubMarketArea("All");
        setMicroMarketArea("All");
        setPropertyType("All");

        closeModal();
    };

    const onSubmit = async () => {
        setSending(true);
        const status = await operations.uploadResearchCaptureJob(
            year,
            quarter,
            marketArea,
            propertyType,
            subMarketArea,
            microMarketArea
        );
        if (status >= 200 && status < 300) {
            snapshotResponse(true);
        } else {
            snapshotResponse(false);
        }
        onExitModal();
    };

    const handleQuarterUpdate = (event) => {
        setQuarter(event.target.value);
    };

    const handleYearUpdate = (event) => {
        setYear(event.target.value);
    };

    const handleMarketAreaUpdate = (event) => {
        setMarketArea(event.target.value);
        setSubMarketArea("All");
        setMicroMarketArea("All");
    };

    const handleSubMarketAreaUpdate = (event) => {
        setSubMarketArea(event.target.value);
        setMicroMarketArea("All");
    };

    const handleMicroMarketAreaUpdate = (event) => {
        setMicroMarketArea(event.target.value);
    };

    const handlePropertyTypeUpdate = (event) => {
        setPropertyType(event.target.value);
    };

    return (
        <Modal
            open={modalOpen}
            onClose={onExitModal}
            style={{
                height: "60vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10vh",
            }}
        >
            <StyledModalContainer>
                <StyledHeaderText>Capture Research</StyledHeaderText>
                <Typography variant="body1" style={{ marginRight: "24px", marginLeft: "24px" }}>
                    Scroll and use the drop downs below to capture research for a corresponding Year, Quarter, Market
                    Area, Submarket Area, Micromarket Area, and Property Type.
                </Typography>
                <StyledSelectionColumn>
                    <BSSelect
                        id="yearSelect"
                        label="Year"
                        value={year}
                        onChange={handleYearUpdate}
                        placeholder="Select a year"
                        options={yearsForResearchSnapshot()}
                        disabled={false}
                    />
                    <BSSelect
                        id="quarterSelect"
                        label="Quarter"
                        value={quarter}
                        onChange={handleQuarterUpdate}
                        placeholder="Select a quarter"
                        options={quarters}
                        disabled={false}
                    />
                    <BSSelect
                        id="marketAreaSelect"
                        label="Market Area"
                        value={marketArea}
                        onChange={handleMarketAreaUpdate}
                        placeholder="Select a market area"
                        options={marketAreasForResearchSnapshot()}
                        disabled={false}
                    />
                    <BSSelect
                        id="subMarketAreaSelect"
                        label="SubMarket"
                        value={subMarketArea}
                        onChange={handleSubMarketAreaUpdate}
                        placeholder="Select a submarket area"
                        options={submarketOptionsForResearch(marketArea)}
                        disabled={marketArea !== "Select" ? false : true}
                    />
                    <BSSelect
                        id="microMarketAreaSelect"
                        label="MicroMarket"
                        value={microMarketArea}
                        onChange={handleMicroMarketAreaUpdate}
                        placeholder="Select a micromarket area"
                        options={micromarketOptionsForResearch(marketArea, subMarketArea)}
                        disabled={marketArea !== "Select" ? false : true}
                    />
                    <BSSelect
                        id="propertyTypeSelect"
                        label="Property Type"
                        value={propertyType}
                        onChange={handlePropertyTypeUpdate}
                        placeholder="Select a property type"
                        options={propertyTypeFilterOptionsForResearchSnapshot()}
                        disabled={false}
                    />
                </StyledSelectionColumn>
                <div
                    style={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "end",
                        margin: "0vw 1vw 1vw 0vw",
                    }}
                >
                    <Button
                        style={{ display: "inline-block", marginLeft: "10px" }}
                        variant="outlined"
                        onClick={onExitModal}
                    >
                        Cancel
                    </Button>
                    <Button
                        style={{ display: "inline-block", marginLeft: "10px" }}
                        variant="contained"
                        color="primary"
                        disabled={quarter !== "Select" && marketArea !== "Select" && sending === false ? false : true}
                        onClick={() => onSubmit()}
                    >
                        Capture
                    </Button>
                </div>
            </StyledModalContainer>
        </Modal>
    );
};

export default ResearchSnapshotModal;
